export const SET_UPLOAD_MESSAGE = 'SET_UPLOAD_MESSAGE'
export const CLOSE_UPLOAD_TASK_BOX = 'CLOSE_UPLOAD_TASK_BOX'
export const SET_UPLOAD_TASK_STATUS = 'SET_UPLOAD_TASK_STATUS'

